export type CheckedState = 'unchecked' | 'indeterminate' | 'checked';

export function parseCheckedState(state: CheckedState): {
  checked: boolean;
  indeterminate: boolean;
} {
  return {
    checked: state === 'checked',
    indeterminate: state === 'indeterminate',
  };
}
